module.exports = __webpack_public_path__ + "https://gloprocessor.com/ment/img/money.125d9621.png";